import React from 'react';
import './App.css';
import { UserProvider } from './Providers/UserProvider';
import Router from './Shared/Router';

function App() {
    return (
        <UserProvider>
            <div className="min-h-screen w-screen">
                <Router />
            </div>
        </UserProvider>
    );
}

export default App;
